import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  parentUnlikeActivityMutationData: any;
  parentUnlikeActivityMutationLoading: boolean;
  parentUnlikeActivityMutationError: SerializedError | null;
} = {
  parentUnlikeActivityMutationData: {},
  parentUnlikeActivityMutationLoading: false,
  parentUnlikeActivityMutationError: null,
};

export const parentUnlikeActivityMutationFunc = createAsyncThunk(
  'parentUnlikeActivityMutation/parentUnlikeActivityMutationFunc',
  async (values: { activityId: null | string }) => {
    const accessTokenJSON = localStorage.getItem('auth') as string;
    const data1 = JSON.stringify({
      query: `mutation ParentUnlikeActivity($activityId: String) {
        parent_unlikeActivity(activityId: $activityId) {
            _id
        }
    }`,
      variables: {
        activityId: values.activityId,
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_ACTIVITY || '',
      data1,
      accessTokenJSON ? JSON.parse(accessTokenJSON).accessToken : ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const parentUnlikeActivityMutation = createSlice({
  name: 'parentUnlikeActivityMutation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(parentUnlikeActivityMutationFunc.pending, (state) => {
      state.parentUnlikeActivityMutationLoading = true;
    });
    builder.addCase(parentUnlikeActivityMutationFunc.fulfilled, (state, action) => {
      state.parentUnlikeActivityMutationLoading = false;
      state.parentUnlikeActivityMutationData = action.payload?.data?.parentUnlikeActivityMutation;
      state.parentUnlikeActivityMutationError =
        action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(parentUnlikeActivityMutationFunc.rejected, (state, action) => {
      state.parentUnlikeActivityMutationLoading = false;
      state.parentUnlikeActivityMutationError = action.error;
    });
  },
});

export default parentUnlikeActivityMutation.reducer;
